export enum ApplicationSearchInteractionType {
  ClickInTheSearchBar = 1,
  BounceOfSearchBar
}
